class JournalSearchForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit(event) {
    const form = event.currentTarget;
    const input = form.querySelector('input[name="q"]');
    if (!input || !form.checkValidity()) return;
    event.preventDefault();
    const query = input.value.trim();
    const destination = new URL(form.action, window.location.origin);
    destination.searchParams.set('q', query);
    destination.searchParams.set('type', 'article');
    destination.searchParams.set('view', 'journal');
    destination.searchParams.set('options[prefix]', 'last');
    window.location.assign(destination.toString());
  }
}

if (!customElements.get('journal-search-form')) {
  customElements.define('journal-search-form', JournalSearchForm);
}
